import { Popper } from '../Popper';
import { ViewPopoverContent } from '../../views/ViewPopoverContent'; // todo 暂时没新的设计图

export var TooltipContent = Popper.withPopperContent(ViewPopoverContent);